import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { LegalProceedingsProcessDataProps } from './props';
import DatePickerField from '../../../../../components/general/fields/datePickerField';
import { useLegalProceedingsProcessData } from './hook';
import Loading from '../../../../../components/general/loadings/loading';

export const LegalProceedingsProcessData = ({
    legalProceeding,
    loading,
}: LegalProceedingsProcessDataProps) => {
    const { formik } = useLegalProceedingsProcessData(legalProceeding);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <DatePickerField
                    label="Fecha de recepción"
                    name="dateReceipt"
                    size="small"
                    value={formik.values.dateReceipt}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Radicado compañia"
                    name="registeredCompany"
                    size="small"
                    value={formik.values.registeredCompany}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Documento accionante"
                    name="documentClaimant"
                    size="small"
                    value={formik.values.documentClaimant}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre accionante"
                    name="nameClaimant"
                    size="small"
                    value={formik.values.nameClaimant}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Documento accionado"
                    name="documentProcessed"
                    size="small"
                    value={formik.values.documentProcessed}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre accionado"
                    name="nameProcessed"
                    size="small"
                    value={formik.values.nameProcessed}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Documento asegurado"
                    name="insuredDocument"
                    size="small"
                    value={formik.values.insuredDocument}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre asegurado"
                    name="insuredName"
                    size="small"
                    value={formik.values.insuredName}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Número requerimiento"
                    name="requirementNumber"
                    size="small"
                    value={formik.values.requirementNumber}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Número expediente"
                    name="fileNumber"
                    size="small"
                    value={formik.values.fileNumber}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre persona subscribe"
                    name="namePersonSubscribe"
                    size="small"
                    value={formik.values.namePersonSubscribe}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Póliza"
                    name="policy"
                    size="small"
                    value={formik.values.policy}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Email remitente"
                    name="senderEmail"
                    size="small"
                    value={formik.values.senderEmail}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Placa"
                    name="plate"
                    size="small"
                    value={formik.values.plate}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <DatePickerField
                    label="Fecha de vencimiento"
                    name="expirationDate"
                    size="small"
                    value={formik.values.expirationDate}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Proc. Judiciales"
                    name="legalProceedings"
                    size="small"
                    value={formik.values.legalProceedings}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="PQR identificada"
                    name="pqrIdentified"
                    size="small"
                    value={formik.values.pqrIdentified}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Entidad remitente"
                    name="submittingEntity"
                    size="small"
                    value={formik.values.submittingEntity}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Dirección"
                    name="address"
                    size="small"
                    value={formik.values.address}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Asunto"
                    name="subject"
                    size="small"
                    value={formik.values.subject}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Ubicación"
                    name="location"
                    size="small"
                    value={formik.values.location}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Ramo"
                    name="bouquet"
                    size="small"
                    value={formik.values.bouquet}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Tema/Detalle"
                    name="detail"
                    rows={2}
                    value={formik.values.detail}
                    onChange={console.log}
                />
            </Grid>
        </Grid>
    );
};
